import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { Infolayer } from '@xingternal/winery-ui/lib/Infolayer';
import type { PropsOf } from '@xingternal/winery-ui/lib/helpers';

const InfolayerOverlay = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: ${themeGet('zIndices.overlayLevel')};
`;

export type InfolayerWithOverlayProps = Pick<PropsOf<typeof Infolayer>, 'isVisible' | 'children' | 'content'>;


const InfolayerWithOverlay = ({ children, isVisible, content, ...rest }: InfolayerWithOverlayProps) => {
  const [isInfoLayerShown, setIsInfoLayerShown] = useState(false);

  useEffect(() => {
    if (isVisible !== undefined) {
      setIsInfoLayerShown(isVisible);
    }
  }, [isVisible]);

  const showInfoLayer = () => {
    const infolayerIsVisible = isVisible !== undefined ? isVisible : true;
    setIsInfoLayerShown(infolayerIsVisible);
  };

  return (
    <>
      <Infolayer isVisible={isInfoLayerShown} content={content} {...rest}>
        {children({ showInfoLayer })}
      </Infolayer>
      {isInfoLayerShown && (
        <InfolayerOverlay
          data-testid="infolayer-overlay"
          onClick={() => setIsInfoLayerShown(false)}
        />
      )}
    </>
  );
};

export { InfolayerWithOverlay };
